import { render, staticRenderFns } from "./ConfirmationCard.vue?vue&type=template&id=a0fbc3dc&scoped=true"
import script from "./ConfirmationCard.ts?vue&type=script&lang=ts&external"
export * from "./ConfirmationCard.ts?vue&type=script&lang=ts&external"
import style0 from "./ConfirmationCard.scss?vue&type=style&index=0&id=a0fbc3dc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fbc3dc",
  null
  
)

export default component.exports